import './frontend.scss';
import Swiper from 'swiper';
import { FreeMode, Mousewheel, Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const initializeSwiper = (contextElement, swiperElement) => {
        if (!swiperElement) {
            return;
        }

        const displayArrows = contextElement.getAttribute('data-display-arrows') === '1';
        const displayDots = contextElement.getAttribute('data-display-dots') === '1';

        const slidesPerViewDesktop = parseFloat(contextElement.getAttribute('data-slides-per-view-desktop')) || 2.5;
        const slidesPerViewTablet = parseFloat(contextElement.getAttribute('data-slides-per-view-tablet')) || 2.5;
        const slidesPerViewMobile = parseFloat(contextElement.getAttribute('data-slides-per-view-mobile')) || 1.5;

        const blockGapDesktop = parseInt(contextElement.getAttribute('data-block-gap-desktop')) || 32;
        const blockGapTablet = parseInt(contextElement.getAttribute('data-block-gap-tablet')) || 32;
        const blockGapMobile = parseInt(contextElement.getAttribute('data-block-gap-mobile')) || 16;

        const nextButton = contextElement.querySelector('.swiper-button-next');
        const previousButton = contextElement.querySelector('.swiper-button-prev');
        const paginationElement = contextElement.querySelector('.swiper-pagination');

        const modules = [
            FreeMode,
            Mousewheel,
            displayArrows === true && nextButton && previousButton ? Navigation : null,
            displayDots === true && paginationElement ? Pagination : null,
        ].filter(mod => mod != null);

        const navigationParams = displayArrows === true && nextButton && previousButton
            ? {
                navigation: {
                    nextEl: nextButton,
                    prevEl: previousButton,
                },
            }
            : {
                navigation: false,
            };

        const paginationParams = displayDots === true && paginationElement
            ? {
                pagination: {
                    el: paginationElement,
                    clickable: true,
                },
            }
            : {
                pagination: false,
            };

        let tablet_bp = parseInt(window.theme_settings?.preferences?.tablet_bp);
        tablet_bp = !Number.isNaN(tablet_bp) ? tablet_bp : 767;

        let pc_bp = parseInt(window.theme_settings?.preferences?.pc_bp);
        pc_bp = !Number.isNaN(pc_bp) ? pc_bp : 1000;

        const options = {
            createElements: true,
            slidesPerView: slidesPerViewMobile,
            spaceBetween: blockGapMobile,
            modules,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            observer: false,
            observeParents: false,
            observeSlideChildren: false,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            ...navigationParams,
            ...paginationParams,
            breakpoints: {
                [tablet_bp]: {
                    slidesPerView: slidesPerViewTablet,
                    spaceBetween: blockGapTablet,
                },
                [pc_bp]: {
                    slidesPerView: slidesPerViewDesktop,
                    spaceBetween: blockGapDesktop,
                },
            },
        };

        new Swiper(swiperElement, options);
    };

    const contextElements = document.querySelectorAll('.wp-block-jims-wp-services-carousel');
    contextElements.forEach((contextElement) => {
        const swiperElement = contextElement.querySelector('.swiper');
        initializeSwiper(contextElement, swiperElement);
    });
});
